module.exports = __webpack_public_path__ + "img/6.b80af602.png";